/**
 * App Store Module
 * Main entry point for the app store module
 */

import type { Module } from '../../index';
import { appStoreRoutes } from './routes/config';

// Export components
export * from './components';

// Export services
export * from './services';

// Export pages
export { default as Dashboard } from './pages/Dashboard';
export { default as AppList } from './pages/AppList';
export { default as AppDetails } from './pages/AppDetails';
export { default as MyApps } from './pages/MyApps';

/**
 * App Store Module Definition
 */
const appStoreModule: Module = {
  name: 'appstore',
  path: '/app/appstore',
  routes: appStoreRoutes,
  components: {
    // Export any shared components here
  },
  services: {
    // Export any shared services here
  },
};

export default appStoreModule;
